import crud from './_crud'
import { callApi } from 'utils/api'
import { showErrorMessage, showSuccessMessage } from 'utils/messages'

const entity = 'trailer'

const getTypesCatalog = (options) => {
	return async (dispatch, getState) => {
		const state = getState()

		const res = await callApi(`/utils/get_trailer_type_catalog`, {
			method: 'GET',
			headers: {
				Authorization: state.app.user.token,
			},
		})

		dispatch({
			type: `GET_${entity.toUpperCase()}_TYPES`,
			response: res.body,
		})

		return res.body
	}
}

const assignTires = ({ unit_params, trailer_id, tires, files = [] }) => {
	return async (dispatch, getState) => {
		const state = getState()

		const res = await callApi(`/${entity}/utils/${trailer_id}/assign_tires`, {
			method: 'PATCH',
			json: false,
			body: {
				tires: JSON.stringify(tires),
				unit_params: JSON.stringify(unit_params),
				identified_files: JSON.stringify(files),
				files: files.map((f) => f.File),
			},
			headers: {
				Authorization: state.app.user.token,
			},
			successMessage: `Se guardo correctamente la asignación de llantas.`,
		})

		// dispatch(actions.get(unit_id))

		return res.body
	}
}

const createTire = ({ trailer_id, body }) => {
	return async (dispatch, getState) => {
		const state = getState()

		const res = await callApi(`/${entity}/${trailer_id}/create_tire`, {
			method: 'POST',
			body: JSON.stringify(body),
			headers: {
				Authorization: state.app.user.token,
			},
			successMessage: `Se guardo correctamente la asignación de llantas.`,
		})

		// dispatch(actions.get(unit_id))

		return res.body
	}
}

const updateTire = ({ trailer_id, body }) => {
	return async (dispatch, getState) => {
		const state = getState()

		const res = await callApi(`/${entity}/${trailer_id}/update_tire`, {
			method: 'POST',
			body: JSON.stringify(body),
			headers: {
				Authorization: state.app.user.token,
			},
			successMessage: `Se guardo correctamente la asignación de llantas.`,
		})

		// dispatch(actions.get(unit_id))

		return res.body
	}
}

const setTrailerTireOperation = (unitParams, options) => {
	return async (dispatch, getState) => {
		const state = getState()

		const res = await callApi(`/${entity}/set_tire_operation`, {
			method: 'POST',
			body: JSON.stringify({
				options: options,
				unit_params: unitParams,
			}),
			headers: {
				Authorization: state.app.user.token,
			},
			successMessage: `Se guardo correctamente la asignación de llantas.`,
		})

		// dispatch(actions.get(unit_id))

		return res.body
	}
}

const getFuelCatalog = (options) => {
	return async (dispatch, getState) => {
		const state = getState()

		const res = await callApi(`/utils/get_fuel_type_catalog`, {
			method: 'GET',
			headers: {
				Authorization: state.app.user.token,
			},
		})

		dispatch({
			type: `GET_${entity.toUpperCase()}_TYPES`,
			response: res.body,
		})

		return res.body
	}
}
const addImage = (trailer_id, files) => {
	return async (dispatch, getState) => {
		const state = getState()

		const res = await callApi(`/trailer/${trailer_id.id}/upload_image`, {
			method: 'PUT',
			json: false,
			headers: {
				Authorization: state.app.user.token,
			},
			body: {
				file: files,
				item: JSON.stringify(trailer_id),
			},
			successMessage: 'Se subió la imagen correctamente',
		})

		// dispatch(actions.get(trailer_id))
	}
}
const deleteTrailer = (item) => {
	return async (dispatch, getState) => {
		const state = getState()
		const res = await callApi(`/trailer/${item.id}/delete_trailer`, {
			method: 'DELETE',
			headers: {
				Authorization: state.app.user.token,
			},
			successMessage: `Se eliminó el remolque correctamente.`,
		})
	}
}
const createTrailerWithImage = (item, files) => {
	return async (dispatch, getState) => {
		const state = getState()

		const res = await callApi(`/trailer/create_trailer_with_image`, {
			method: 'PUT',
			json: false,
			headers: {
				Authorization: state.app.user.token,
			},
			body: {
				file: files,
				item: JSON.stringify(item),
			},

			successMessage: 'Se agrego el remolque correctamente',
		})

		return res.body
	}
}
const deleteImage = (trailer_id) => {
	return async (dispatch, getState) => {
		const state = getState()

		const res = await callApi(`/trailer/${trailer_id.id}/image`, {
			method: 'DELETE',
			json: false,
			headers: {
				Authorization: state.app.user.token,
			},
			successMessage: 'Se eliminó la imagen correctamente',
		})

		// dispatch(actions.get(trailer_id))
	}
}

const importTrailers = (options) => {
	return async (dispatch, getState) => {
		const state = getState()

		const res = await callApi(`/trailer/import_trailers`, {
			method: 'POST',
			headers: {
				Authorization: state.app.user.token,
			},
			body: JSON.stringify({
				options,
			}),
			successMessage: `Se agreron los remolques correctamente.`,
		})
		showSuccessMessage('Se registraron los remolques correctamente')
		return res.body
	}
}

//getTrailerOdometerHistory

const getTrailerOdometerHistory = (query) => {
	return async (dispatch, getState) => {
		const state = getState()

		const res = await callApi(`/trailer_odometer_history/utils/get_trailer_odometer_history`, {
			method: 'GET',
			headers: {
				Authorization: state.app.user.token,
			},
			params: query,
		})

		return res.body
	}
}

const getTrailerOdometerHistoryByUsertype = ({ userType }, query) => {
	return async (dispatch, getState) => {
		const state = getState()

		const res = await callApi(
			`/trailer_odometer_history/get_trailer_odometer_history_by_usertype`,
			{
				method: 'GET',
				headers: {
					Authorization: state.app[userType].token,
				},
				params: query,
			}
		)

		return res.body
	}
}

const loadTrailersByUsertype = ({ userType }) => {
	return async (dispatch, getState) => {
		const state = getState()

		const res = await callApi(`/trailer/get_trailers_by_usertype`, {
			method: 'GET',
			headers: {
				Authorization: state.app[userType].token,
			},
			params: {
				userType: userType,
				sys_company_id: state.app[userType].sys_company_id,
				[`${userType}_id`]: state.app[userType].id,
			},
		})

		dispatch({
			type: `GET_ALL_TRAILERS_BY_USERTYPE`,
			payload: res.body,
		})

		return res.body
	}
}

const getTrailerWithSensors = (trailer_id) => {
	return async (dispatch, getState) => {
		const state = getState()

		try {
			const res = await callApi(`/trailer/utils/get_trailer_sensors_list`, {
				method: 'GET',
				headers: {
					Authorization: state.app.user.token,
				},
				params: trailer_id
			})

			return res.body
		} catch (error) {
			console.log(error)
			return []
		}
	}
}

const getUnimportedWialonTrailers = () => {
	return async (dispatch, getState) => {
		const state = getState()

		try {
			const resp = await callApi('/wialon/not_imported_trailers', {
				headers: {
					Authorization: state.app.user.token,
				},
			})

			return resp.body
		} catch (error) {
			console.log(error)
		}
	}
}

const getCustomTrailers = (params) => {
	return async (dispatch, getState) => {
		const state = getState()

		const res = await callApi(`/trailer/custom_trailers`, {
			method: 'GET',
			headers: {
				Authorization: state.app.user.token,
			},
			params,
		})

		return res.body
	}
}

let customActions = {}
customActions = {
	...customActions,
	getTypesCatalog,
	getFuelCatalog,
	assignTires,
	createTire,
	updateTire,
	setTrailerTireOperation,
	addImage,
	deleteImage,
	deleteTrailer,
	createTrailerWithImage,
	importTrailers,
	getTrailerOdometerHistory,
	loadTrailersByUsertype,
	getTrailerOdometerHistoryByUsertype,
	getTrailerWithSensors,
	getUnimportedWialonTrailers,
	getCustomTrailers,
}

const actions = {
	...crud('trailer', 'el remolque', 'los remolques'),
	...customActions,
}

export default actions
